import { render, staticRenderFns } from "./community-list.vue?vue&type=template&id=b29de40a&"
import script from "./community-list.vue?vue&type=script&lang=ts&"
export * from "./community-list.vue?vue&type=script&lang=ts&"
import style0 from "./community-list.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports